import React from 'react';
import { useTheme } from '@/hooks/useTheme';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

const ThemeSwitcher: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation('common');

  // icon-moon when light (to switch to dark), icon-sun when dark (to switch to light)
  return (
    <button
      className={`${styles.control} h5`}
      onClick={toggleTheme}
      aria-label={t('toggleTheme')}
    >
      <i className={theme === 'light' ? 'icon-moon' : 'icon-sun'} />
      <span className={styles.label}>{t('theme')}</span>
    </button>
  );
};

export default ThemeSwitcher;
